module.exports = __webpack_public_path__ + "static/media/  (106).419f8ba7.jpg";